export default __webpack_public_path__ + "static/media/prev-E1A-6.f2b884dd.png";